import React from "react";
import Image from "@/component/c-image";

import styles from "./style";

const WorldCupBanner = () => {
  return (
    <>
      <div className="world-cup-banner">
        <div className="world-cup-banner--container">
          <div className="world-cup-banner--desktop">
            <Image
              className="world-cup-banner--image"
              src={
                "/content/dam/movistar/estaticos/fondos/mundial-pantalla-grande.jpg"
              }
              width={1500}
              height={150}
              alt=""
              objectFit="contain"
            />
          </div>
          <div className="world-cup-banner--mobile">
            <Image
              className="world-cup-banner--image"
              src={
                "/content/dam/movistar/estaticos/fondos/mundial-pantalla-grande-2-m.jpg"
              }
              width={1000}
              height={150}
              alt=""
              objectFit="contain"
            />
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default WorldCupBanner;
